<!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
<label id="div-values-{{filter.id}}">
  <spot-switch name="v[{{filter.name}}]"
    [ngModel]="value"
    (ngModelChange)="onFilterUpdated($event)"
   />
</label>
